import { render, staticRenderFns } from "./TabPageTemplate.vue?vue&type=template&id=3aa2bb39&scoped=true&"
import script from "./TabPageTemplate.vue?vue&type=script&lang=js&"
export * from "./TabPageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./TabPageTemplate.vue?vue&type=style&index=0&id=3aa2bb39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa2bb39",
  null
  
)

export default component.exports